import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate, formateDateWithMonth, getFormatedTime, handleServerValidations } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import { subscribeForPremium, subscriptionHistoryList, unsubscribeFromPremium, userDetails } from "../../services/user.service";
import Swal from "sweetalert2";
import { SUBSCRIPTION_NAMES, SUBSCRIPTION_PRODUCT_IDS, SWAL_SETTINGS } from "../../../../utils/Constants";
import { SubscriptionHistoryList } from "../../services/subscriptionPlan.services";
import CustomRangepicker from "../../common/rangepicker";
import CustomPagination from "../../common/custompagination";


const UserView = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();
    // const [query] = useSearchParams();
    const SECTIONS = [
        { key: "user-details", label: "View Details", path: `/admin/user-management/user/view/user-details/${params.id}/${params.pgno}` },
        { key: "user-activity", label: "Question History", path: `/admin/user-management/user/view/user-details/${params.id}/${params.pgno}/user-activity/1` },
        { key: "report-history", label: "Report History", path: `/admin/user-management/user/view/user-details/${params.id}/${params.pgno}/report-history/1` }
    ];


    const breadcrumbs = [
        { title: t("link_dashboard"), url: "/admin/dashboard" },
        { title: t("User"), url: `/admin/user-management/user/list/${params.pgno}` },
        { title: t("View"), url: "" },
    ];

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <ul className="nav nav-tabs mt-3 ms-4">
                            {/* {
                                SECTIONS.map(section=>
                                    <li className="nav-item">
                                        <button className={`nav-link ${activeTab === "details" ? "active" : ""}`} onClick={() => setActiveTab("details")}>
                                            {t("View Details")}
                                        </button>
                                    </li>
                                )
                            } */}

                            <div className="d-flex border-bottom pb-2">
                                {SECTIONS.map((section) => (
                                    <NavLink
                                    key={section.key}
                                    to={section.path}
                                    end
                                    className={({ isActive }) =>
                                        `btn mr-2 nav-link ${
                                        isActive ? "active" : ""
                                        }`
                                    }
                                    >
                                    {section.label}
                                    </NavLink>
                                ))}
                            </div>
                        </ul>
                                
                        {/* Child Route Content */}
                        <Outlet />

                    </div>
                </div>
            </div>
        </>
    );
};

export default UserView;
